import { Controller } from "@hotwired/stimulus";

/**
 * Manages the "More" bottom sheet in the mobile navigation bar.
 */
export default class extends Controller {
  static targets = ["sheet", "backdrop", "panel"];

  declare readonly sheetTarget: HTMLElement;
  declare readonly backdropTarget: HTMLElement;
  declare readonly panelTarget: HTMLElement;

  private isOpen = false;

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.sheetTarget.hidden = false;

    requestAnimationFrame(() => {
      this.element.setAttribute("data-bottom-sheet-state", "open");
    });

    document.body.setAttribute("data-budgeter-bottom-sheet-open", "");
  }

  close() {
    this.isOpen = false;
    this.element.setAttribute("data-bottom-sheet-state", "closed");
    document.body.removeAttribute("data-budgeter-bottom-sheet-open");

    setTimeout(() => {
      if (!this.isOpen) {
        this.sheetTarget.hidden = true;
      }
    }, 300);
  }

  disconnect() {
    document.body.removeAttribute("data-budgeter-bottom-sheet-open");
  }
}
